'use client'

import { Fragment, MouseEvent, useState } from 'react'
import { Icon } from '../Icon'
import { AnimatePresence, motion } from 'framer-motion'
import { ClickOutsideDetector } from '../ClickOutsideDetector'
import classNames from 'classnames'
import { GenericLink } from '../GenericLink'

type Props = {
  menu: {
    id: string
    text: string
  }[]
  size?: number
  onClick?: (id: string) => void
  iconClassName?: string
}

export const MoreButton = ({ menu, size, iconClassName, onClick }: Props) => {
  const [open, toggle] = useState(false)

  const onClickWrap = (event: MouseEvent, id: string) => {
    toggle(false)
    event.preventDefault()
    event.stopPropagation()
    onClick?.(id)
  }

  return (
    <div className="relative">
      <Icon
        name="more"
        size={size || 20}
        className={classNames(
          '!text-gray-500 cursor-pointer select-none',
          iconClassName,
        )}
        onClick={() => toggle((prev) => !prev)}
      />
      <AnimatePresence>
        {open && (
          <ClickOutsideDetector onClickOutside={() => toggle(false)}>
            <motion.ul
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="absolute right-0 top-0 border border-gray-400 rounded-lg bg-gray-0 py-1 whitespace-nowrap z-[9999]"
            >
              {menu.map((f, i) => {
                return (
                  <Fragment key={f.id}>
                    <GenericLink
                      className="px-3 py-2 flex gap-1 items-center cursor-pointer"
                      onClick={(e) => onClickWrap(e, f.id)}
                      privilege
                    >
                      <span className="text-body2 font-medium leading-tight">
                        {f.text}
                      </span>
                    </GenericLink>
                    {i < menu.length - 1 && (
                      <hr className="mx-3 border-gray-200" />
                    )}
                  </Fragment>
                )
              })}
            </motion.ul>
          </ClickOutsideDetector>
        )}
      </AnimatePresence>
    </div>
  )
}
